export default "__VITE_ASSET__Bw$klDnM__"